<template>
  <div class="mydialog big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <EditInfo :isFlag="save_dia"
              :doctorInfo="doctorInfo"
              :doctorId="doctorId"
              :isEdit="is_edit"
              @refreshList="getList"></EditInfo>
    <InsurancePolicy :isFlag="upload_dia"
                     :doctorId="doctorId"
                     :isEdit="is_edit"
                     @refreshList="getList"></InsurancePolicy>
    <el-dialog :visible.sync="dialogVisible"
               width="900px"
               :destroy-on-close="true">
      <div style="min-height: 500px; max-height: 700px">
        <video :src="preUrl"
               controls="controls"
               v-if="isvideo"
               style="width: 100%; max-height: 650px">
          您的浏览器不支持视频播放
        </video>
        <img :src="preUrl"
             alt
             v-else
             style="width: 100%; max-height: 650px" />
      </div>
    </el-dialog>

    <div class="page_title">医生医责险管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div class="item">
                <span class="searchtitle">医生姓名</span>
                <el-input v-model="doctor_name"
                          @change="search"
                          clearable
                          class="inputclass"></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">手机号</span>
                <el-input v-model="phone"
                          class="inputclass"
                          @change="search"
                          clearable></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">医院</span>
                <el-input v-model="hospital"
                          class="inputclass"
                          @change="search"
                          clearable></el-input>
              </div>
              <div class="item">
                <span class="searchtitle">医责险</span>
                <span>
                  <el-radio-group v-model="is_safe"
                                  @change="search"
                                  style="margin-bottom:-2px">
                    <el-radio :label="''">全部</el-radio>
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                  </el-radio-group>
                </span>
              </div>
              <div class="item">
                <span class="searchtitle">状态</span>
                <el-select v-model="status"
                           placeholder="请选择">
                  <el-option label="全部"
                             :value="''" />
                  <el-option label="未上传"
                             :value="4" />
                  <el-option label="已上传待处理"
                             :value="1" />
                  <el-option label="处理中"
                             :value="2" />
                  <el-option label="已上传保单"
                             :value="3" />

                </el-select>
              </div>
              <div class="item">
                <span class="searchtitle">资料上传时间</span>
                <el-date-picker v-model="date1"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                style="width: 225px"
                                @change="search"></el-date-picker>
              </div>
              <div class="item">
                <span class="searchtitle">标记为处理中</span>
                <el-date-picker v-model="date2"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                style="width: 225px"
                                @change="search"></el-date-picker>
              </div>
              <div class="item">
                <span class="searchtitle">保单上传时间</span>
                <el-date-picker v-model="date3"
                                type="daterange"
                                range-separator="~"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                style="width: 225px"
                                @change="search"></el-date-picker>
              </div>
              <div class="item">
                <span class="searchtitle">是否测试</span>
                <span>
                  <el-radio-group v-model="is_test"
                                  @change="search"
                                  style="margin-bottom:-2px">
                    <el-radio :label="''">全部</el-radio>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </span>
              </div>
              <div class="item">
                <el-button type="info"
                           style="background-color: #eceff2; color: #747981"
                           @click="search">查询</el-button>
                <el-button plain
                           @click="resetAll">重置</el-button>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%; min-width: 1000px"
                        :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column label="医生头像"
                                 width="100">
                  <template slot-scope="scope">
                    <img :src="scope.row.head_img"
                         alt
                         style="width: 40px; height: 40px" />
                  </template>
                </el-table-column>
                <el-table-column label="医生信息"
                                 width="140">
                  <template slot-scope="scope">
                    <div>
                      <span @click="showDocMsg(scope.row.doctor_id)"
                            style="cursor:pointer;margin-right:10px">{{ scope.row.doctor_name }}</span>
                      <span v-if="scope.row.sex == 1">男</span>
                      <span v-if="scope.row.sex == 2">女</span>
                    </div>
                    <div>{{scope.row.title}}</div>
                    <div>{{scope.row.phone}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="科室"
                                 prop="department_name"
                                 width="140"></el-table-column>
                <el-table-column label="医院"
                                 prop="hospital"></el-table-column>
                <el-table-column label="地区">
                  <template slot-scope="scope">
                    <span>{{scope.row.province_name}}{{scope.row.city_name}}{{scope.row.district_name}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">已上传待处理</div>
                    <div v-if="scope.row.status == 2">已上传处理中</div>
                    <div v-if="scope.row.status == 3">已上传保单</div>
                    <div v-if="scope.row.status == 4">未上传</div>
                    <div v-if="scope.row.status == 1">资料上传时间：{{scope.row.create_time}}</div>
                    <div v-if="scope.row.status == 2">标记为处理中时间：{{scope.row.sign_time}}</div>
                    <div v-if="scope.row.status == 3">保单上传时间：{{scope.row.upload_time}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="医责险"
                                 width="150">
                  <template slot-scope="scope">
                    <span v-if="scope.row.is_safe">开启</span>
                    <span v-else>关闭</span>
                    <el-switch style="margin-left:10px"
                               v-model="scope.row.is_safe"
                               :active-value="1"
                               :inactive-value="0"
                               @change="(value)=>{return setIsSafe(value,scope.row.doctor_id)}"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="操作"
                                 align="center"
                                 width="210">
                  <template slot-scope="scope">
                    <el-button type="text"
                               @click="saveInfo(scope.row,0)"
                               v-if="scope.row.status == 4"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1323')
                          : false
                      ">上传资料</el-button>
                    <el-button type="text"
                               @click="saveInfo(scope.row,2)"
                               v-if="scope.row.status != 4"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1324')
                          : false
                      ">查看资料</el-button>
                    <el-button type="text"
                               @click="saveInfo(scope.row,1)"
                               v-if="scope.row.status != 4"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1325')
                          : false
                      ">编辑资料</el-button>
                    <el-button type="text"
                               v-if="scope.row.status == 2"
                               @click="uploadImg(scope.row.doctor_id,0)"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1326')
                          : false
                      ">上传保单</el-button>
                    <el-button type="text"
                               v-if="scope.row.status == 3"
                               @click="uploadImg(scope.row.doctor_id,1)"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1326')
                          : false
                      ">编辑保单</el-button>
                    <el-button type="text"
                               v-if="scope.row.status == 3"
                               @click="uploadImg(scope.row.doctor_id,2)"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1326')
                          : false
                      ">查看保单</el-button>
                    <el-button type="text"
                               v-if="scope.row.status == 1"
                               @click="setSafeDealing(scope.row.doctor_id)"
                               :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1326')
                          : false
                      ">标记为处理中</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="pagesize"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="totalNum"
                             style="margin:20px 0"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import DocMsg from '../../../components/common/DocMsg.vue';
import EditInfo from './EditInfo.vue';
import InsurancePolicy from './InsurancePolicy.vue';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      phone: '',
      hospital: '',
      is_safe: '',
      status: '',
      is_test: 0,
      date1: [],
      date2: [],
      date3: [],
      video_on: require('@/assets/img/video.svg'),
      dialogVisible: false,
      isvideo: 0,
      preUrl: '',
      uploadExtraData: {
        img_type: 1,
        suffix: '.jpg'
      },
      upload: false,
      videoUrl: '',
      mianUrl: '',
      video_path: '',
      main_path: '',
      doctorId: '',
      doc_msg: false,
      doctorId: '',
      save_dia: false,
      upload_dia: false,
      is_edit: 0,
      doctorInfo: {}
    };
  },
  components: {
    DocMsg,
    EditInfo,
    InsurancePolicy
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.phone,
        hospital: this.hospital,
        is_safe: this.is_safe,
        status: this.status,
        is_test: this.is_test
      };
      if (this.date1 && this.date1.length > 0) {
        data.create_time_start = dayjs(this.date1[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date1[1]).format('YYYY-MM-DD');
      }
      if (this.date2 && this.date2.length > 0) {
        data.sign_time_start = dayjs(this.date2[0]).format('YYYY-MM-DD');
        data.sign_time_end = dayjs(this.date2[1]).format('YYYY-MM-DD');
      }
      if (this.date3 && this.date3.length > 0) {
        data.upload_time_start = dayjs(this.date3[0]).format('YYYY-MM-DD');
        data.upload_time_end = dayjs(this.date3[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Doctor/doctorSafeList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = item.create_time
                ? dayjs.unix(item.create_time).format('YYYY-MM-DD HH:mm')
                : '';
              item.upload_time = item.upload_time
                ? dayjs.unix(item.upload_time).format('YYYY-MM-DD HH:mm')
                : '';
              item.sign_time = item.sign_time
                ? dayjs.unix(item.sign_time).format('YYYY-MM-DD HH:mm')
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetAll() {
      this.doctor_name = '';
      this.phone = '';
      this.hospital = '';
      this.is_safe = '';
      this.status = '';
      this.is_test = 0;
      this.date1 = [];
      this.date2 = [];
      this.date3 = [];
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //上传保单
    uploadImg(doctor_id, is_edit) {
      this.doctorId = doctor_id;
      this.is_edit = is_edit;
      this.upload_dia = !this.upload_dia;
    },
    //上传资料
    saveInfo(row, is_edit) {
      this.doctorInfo = {
        doctor_id: row.doctor_id,
        doctor_name: row.doctor_name_str,
        id_card: row.id_card,
        practice_category: row.practice_category,
        practice_certificate_num: row.practice_certificate_num
      };
      this.doctorId = row.doctor_id;
      this.is_edit = is_edit;
      this.save_dia = !this.save_dia;
    },
    //医责险开关
    setIsSafe(value, doctor_id) {
      let data = {
        is_safe: value,
        doctor_id
      };
      this.$confirm('确定修改医责险开启状态吗？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios.post('platform/Doctor/setIsSafe', data).then((res) => {
            if (res.code == 0) {
              this.$message.success('修改成功');
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //标记为处理中
    setSafeDealing(doctor_id) {
      this.axios
        .post('platform/Doctor/setSafeDealing', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('已标记为处理中');
            this.getList();
          }
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    margin-right: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  .inputclass {
    width: 180px;
  }
  .searchtitle {
    display: inline-block;
    width: 90px;
    text-align: right;
    box-sizing: border-box;
    margin-right: 8px;
  }
}
</style>